import { DataTransferBothIcon } from '@synoptic/ui-kit/icons/react/data-transfer-both.tsx';
import { PackagesIcon } from '@synoptic/ui-kit/icons/react/packages.tsx';
import { ReceiveDollarsIcon } from '@synoptic/ui-kit/icons/react/receive-dollars.tsx';
import { StreamPricingType } from '@/components/streams/stream-pricing-type';
import { StreamSelectionItem } from '../stream-selection-tag-group/stream-selection-tag-group';

export const pricingToggleItems: StreamSelectionItem[] = [
  {
    title: 'Free',
    value: StreamPricingType.Free,
    icon: <DataTransferBothIcon />,
    description:
      'Share your content with your audience at no cost. Free streams are perfect for engaging with followers.',
  },
  {
    title: 'Paid',
    value: StreamPricingType.Paid,
    icon: <ReceiveDollarsIcon />,
    description:
      'Monetize your content and earn from your subscribers by offering a paid stream with exclusive value.',
  },
  {
    title: 'In-package',
    value: StreamPricingType.PackageOnly,
    icon: <PackagesIcon />,
    description:
      'Make this stream available only in packages. Offer unique content that can’t be purchased on its own.',
  },
];
